module.exports = __webpack_public_path__ + "img/53.39a1970f.jpg";